export interface InventoryCsvRow {
  sku: string;
  name: string;
  category: string;
  stock: number;
  price: number;
  active: boolean;
}

function cell(value: string | number): string {
  let text = String(value);
  if (/^[=+\-@]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}

export function inventoryCsv(rows: InventoryCsvRow[]): string {
  const header = ["SKU", "Producto", "Categoría", "Stock", "Precio", "Estado"];
  const lines = rows.map((row) =>
    [
      row.sku,
      row.name,
      row.category,
      row.stock,
      row.price.toFixed(2),
      row.active ? "Activo" : "Inactivo",
    ]
      .map(cell)
      .join(","),
  );
  return `\uFEFF${[header.map(cell).join(","), ...lines].join("\r\n")}`;
}
